import React, { useMemo, useEffect, useState } from 'react';
import { PieChart } from 'react-minimal-pie-chart';
import dayjs from 'dayjs';
import axios from 'axios';
import Button from './Button';
import Spinner from './Spinner';

import timezone from 'dayjs/plugin/timezone';
import clsx from 'clsx';

dayjs.extend(timezone);
dayjs.tz.setDefault('America/New_York');

const StatsPies = () => {
  const [timeFrame, setTimeFrame] = useState('24H');
  const [flips, setFlips] = useState([]);
  const [loading, setLoading] = useState(true);
  const heads = flips.filter((flip) => flip.coinFlipResult === 'heads');
  const tails = flips.filter((flip) => flip.coinFlipResult === 'tails');
  const didWin = flips.filter((flip) => flip.didWin === true);
  const didLose = flips.filter((flip) => flip.didWin === false);

  const defaultLabelStyle = {
    fontSize: '8px',
    fill: '#ffffff',
    fontFamily: 'sans-serif',
  };

  const onFetchFlips = async () => {
    const subtractBy = timeFrame === '24H' ? 1 : 7;
    const after = dayjs().subtract(subtractBy, 'day').format('YYYY-MM-DD');

    const { data } = await axios.get('/api/flips/stats', {
      params: {
        after,
      },
      headers: {
        Authorization: process.env.NEXT_PUBLIC_API_KEY,
      },
    });
    setLoading(false);
    setFlips(data);
  };

  useEffect(() => {
    onFetchFlips();
  }, [timeFrame]);

  return (
    <div className='flex flex-col gap-6'>
      <div className='flex gap-3'>
        <Button
          theme='none'
          className={clsx(
            'font-medium text-sm uppercase px-3 py-1 border-2 border-gray-600 rounded-full',
            timeFrame === '24H' && 'bg-gray-600 text-white'
          )}
          onClick={() => setTimeFrame('24H')}
        >
          24H
        </Button>
        <Button
          theme='none'
          className={clsx(
            'font-medium text-sm uppercase px-3 py-1 border-2 border-gray-600 rounded-full',
            timeFrame === '1W' && 'bg-gray-600 text-white'
          )}
          onClick={() => setTimeFrame('1W')}
        >
          1W
        </Button>
      </div>

      {loading ? (
        <div className='mt-5 flex justify-center'>
          <Spinner />
        </div>
      ) : (
        <div className='flex justify-center gap-6 mt-3 m w-full mx-auto flex-col md:flex-row'>
          <div className='flex flex-col gap-6 items-center justify-center px-20'>
            <PieChart
              label={({ dataEntry }) => `${dataEntry.value}%`}
              data={[
                { title: 'Heads', value: Math.round((heads.length / flips.length) * 100), color: '#9E005D' },
                { title: 'Tails', value: Math.round((tails.length / flips.length) * 100), color: '#84C341' },
              ]}
              labelStyle={{
                ...defaultLabelStyle,
              }}
            />
            <p className='font-bold text-center text-sm'>Heads/Tails</p>
          </div>

          <div className='flex flex-col gap-6 items-center justify-center px-20'>
            <PieChart
              label={({ dataEntry }) => `${dataEntry.value}%`}
              data={[
                { title: 'Wins', value: Math.round((didWin.length / flips.length) * 100), color: '#9E005D' },
                { title: 'Losses', value: Math.round((didLose.length / flips.length) * 100), color: '#84C341' },
              ]}
              labelStyle={{
                ...defaultLabelStyle,
              }}
            />
            <p className='font-bold text-center text-sm'>Wins/Losses</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatsPies;
